<template>
  <div class="container">
    <div class="header">
      <div class="w1250">
        <z-header></z-header>
      </div>
    </div>
    <div
      class="main w1200"
      v-if="!isBrandZZFlag && pageInfo && pageInfo.hasOwnProperty('pageInfo')"
    >
      <z-breadcrumb
        v-if="pageInfo.pageInfo.hasOwnProperty('breadcrumbs')"
        :visible="false"
        :options="pageInfo.pageInfo.breadcrumbs"
      ></z-breadcrumb>
      <el-row>
        <el-col :span="18">
          <span class="ad_tit">广告资质投放类型</span>
          <el-tooltip placement="bottom-start" effect="light" class="tooltip">
            <span class="zizhi-tips" slot="content"
              >注意：以下资质仅影响广告的审核；相同的资质只需上传一次，所有广告都能复用。</span
            >
            <i class="el-icon-warning icon-color-gray" />
          </el-tooltip>
        </el-col>
        <el-col :span="4">
          <div class="help_tit" @click="jumpHelpCenter">帮助中心</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col
          :span="6"
          v-for="(item, key) in pageInfo.cards.announcement.items"
          :key="key"
        >
          <el-card>
            <div class="txt-align-center panel-item">
              <div class="f-weight">{{ item.desc }}</div>
              <div class="s_txt">{{ item.desc1 }}</div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <div style="margin-top: 4px; margin-bottom: -3px">
        <span class="f-weight ad_tit">资质证明</span>
      </div>
      <el-tabs type="border-card">
        <el-tab-pane label="主体资质">
          <el-row>
            <el-row :gutter="20" class="h80">
              <el-col :span="20">
                <div class="grid-content"></div>
              </el-col>
              <el-col
                :span="4"
                style="text-align: right"
                v-if="mainQualificationInfo.data.length == 0"
              >
                <el-button
                  size="medium"
                  type="primary"
                  @click="jumpToPro"
                  style="margin-right: 28px"
                  >主体资质填写</el-button
                >
              </el-col>
            </el-row>
            <el-col class="tabBg">
              <el-table
                :data="mainQualificationInfo.data"
                style="width: 100%"
                :header-row-class-name="headerRow"
                :row-class-name="rowClass"
                :cell-class-name="cellClass"
              >
                <el-table-column
                  prop="qualificationTypeName"
                  label="资质类型"
                  width="140"
                >
                  <template slot-scope="scope">
                    <el-tooltip effect="light" placement="top">
                      <i
                        class="el-icon-warning icon-gray"
                        v-if="scope.row.status == 5 || scope.row.validityStatus"
                      />
                      <div slot="content">
                        <span v-if="scope.row.validityStatus"
                          >资质即将到期，请尽快变更</span
                        >
                        <span v-else
                          >审核通过后，将覆盖当前使用的主体资质信息</span
                        >
                      </div>
                    </el-tooltip>
                    <div
                      v-bind:title="scope.row.qualificationTypeName"
                      class="text-index-t"
                    >
                      {{ scope.row.qualificationTypeName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="qualificationName"
                  label="资质名称"
                  width="220"
                >
                  <template slot-scope="scope">
                    <div
                      v-bind:title="scope.row.qualificationName"
                      class="text-index-t"
                    >
                      {{ scope.row.qualificationName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="qualificationCode"
                  label="资质编号"
                  width="220"
                >
                  <template slot-scope="scope">
                    <div
                      v-bind:title="scope.row.qualificationCode"
                      class="text-index-t"
                    >
                      {{ scope.row.qualificationCode }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="qualificationValidDate"
                  label="有效期"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="desc"
                  column-key="desc"
                  label="状态"
                  width="145"
                  class="colorzt"
                >
                  <template slot-scope="scope">
                    {{ scope.row.desc }}
                    <el-tooltip
                      effect="light"
                      v-if="scope.row.status == 6 && scope.row.reason"
                      placement="top"
                    >
                      <i class="el-icon-warning icon-color" />
                      <div slot="content" style="color: #c82439">
                        {{ scope.row.reason }}
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="updateTime"
                  width="220"
                  label="最后编辑时间"
                >
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="130">
                  <template slot-scope="scope">
                    <el-button type="text" @click="jumpToPro(scope.row, 1)"
                      >查看</el-button
                    >
                    <el-button
                      v-if="checkEditFlag(scope.row)"
                      type="text"
                      @click="jumpToPro(scope.row, 2)"
                      >编辑</el-button
                    >
                  </template>
                </el-table-column>
                <div slot="empty" class="table-empty">
                  <img
                    width="120px"
                    height="120px"
                    src="//n.sinaimg.cn/default/594854f7/20180713/table_empty.png"
                  />
                  <p>
                    暂无资质信息
                    <button @click="jumpToPro">立即添加相关资质 &gt;</button>
                  </p>
                </div>
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="行业资质">
          <el-row>
            <el-row :gutter="20" class="h80" style="display: flex;">
              <el-col :span="5">
                <el-input
                  @keyup.enter.native="search"
                  v-model="search_word"
                  suffix-icon="el-icon-search"
                  placeholder="请输入资质包名称"
                  style="margin-left: 28px; line-height: 32px; height: 32px"
                ></el-input>
              </el-col>
              <el-col :span="11">
                <div class="grid-content"></div>
              </el-col>
              <el-col :span="8" style="text-align: right;display: flex;align-items: center;justify-content: flex-end;">
                <el-button
                  size="medium"
                  type="primary"
                  @click="jump"
                  style="margin-right: 10px"
                  >添加资质证明</el-button
                >
                  <el-button
                  size="medium"
                  type="primary"
                  @click="copyQual"
                  style="margin-right: 28px"
                  >复制资质证明</el-button>
              </el-col>
            </el-row>
            <el-col class="tabBg">
              <el-table
                :data="pageInfo.cards.table.table_data"
                style="width: 100%"
                @filter-change="handlerFilterChange"
                :header-row-class-name="headerRow"
                :row-class-name="rowClass"
                :cell-class-name="cellClass"
              >
                <el-table-column prop="packageName" label="名称" width="260">
                  <template slot-scope="scope">
                    <div
                      v-bind:title="scope.row.packageName"
                      class="text-index-w"
                    >
                      {{ scope.row.packageName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="industry_type" label="行业" width="220">
                  <template slot-scope="scope">
                    <div
                      v-bind:title="scope.row.industry_type"
                      class="text-index-t"
                    >
                      {{ scope.row.industry_type }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="validityTime" label="有效期" width="160">
                </el-table-column>
                <el-table-column
                  prop="status_type"
                  column-key="status"
                  label="状态"
                  width="120"
                  :filters="filter_data"
                  class="colorzt"
                >
                  <template slot-scope="scope">
                    {{ scope.row.status_type }}
                    <el-tooltip
                      effect="light"
                      v-if="(scope.row.status_type == '驳回' || scope.row.status_type == '过期') && scope.row.subStatusDesc"
                      placement="top"
                    >
                      <i class="el-icon-warning icon-color" />
                      <div slot="content">
                        {{ scope.row.subStatusDesc }}
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      effect="light"
                      v-if="
                        scope.row.status_type == '有效' &&
                        scope.row.industry_status === 1
                      "
                      placement="top"
                    >
                      <i class="el-icon-warning icon-color" />
                      <div slot="content" style="color: #c82439">
                        该资质包对应资质行业有调整，不提供修改功能，且不允许关联新创意
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="updateTime" width="240" label="编辑时间">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="140">
                  <template slot-scope="scope">
                    <el-tooltip effect="light" placement="top">
                      <!-- <w-icon name="1px_preview" @click="show_detail(scope.row)" class="icon-color-show"></w-icon> -->
                      <i
                        class="el-icon-view icon-color-show"
                        @click="show_detail(scope.row)"
                      />
                      <div slot="content">点击查看详情</div>
                    </el-tooltip>
                    <el-tooltip
                      effect="light"
                      placement="top"
                      v-if="scope.row.allow_modify === 1"
                    >
                      <i
                        class="el-icon-edit icon-color-show"
                        @click="show_mature_detail(scope.row)"
                      />
                      <div slot="content">点击进行修改</div>
                    </el-tooltip>
                    <!-- 删除功能，一期暂时不上线 -->
                    <!-- <w-icon name="1px_delete" @click="delete_item(scope.row)" class="icon-color-delete"></w-icon> -->
                  </template>
                </el-table-column>
                <div slot="empty" class="table-empty">
                  <img
                    width="120px"
                    height="120px"
                    src="//n.sinaimg.cn/default/594854f7/20180713/table_empty.png"
                  />
                  <p>
                    暂无资质信息
                    <button @click="jump">立即添加相关资质 &gt;</button>
                  </p>
                </div>
              </el-table>
            </el-col>
            <el-col class="pagination">
              <div class="mar-bot-80">
                <el-pagination
                  hide-on-single-page
                  background
                  :total="pageInfo.cards.table.total"
                  @current-change="change_page"
                  :page-size="10"
                  :layout="
                    pageInfo.cards.table.showForward
                      ? 'prev, pager, next, jumper'
                      : 'prev, pager, next'
                  "
                ></el-pagination>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <!-- <el-tab-pane label="其他资质"></el-tab-pane> -->
      </el-tabs>
    </div>
    <div class="main w1200" v-if="isBrandZZFlag">
      <div class="el-divider el-divider--horizontal">
        <div class="el-divider__text is-left">当前客户</div>
      </div>
      <div class="cust-info">
        <span>客户编号：{{ mainQualInfo.clientNumber }}</span>
        <div class="el-divider el-divider--vertical"></div>
        <span>客户名称：{{ mainQualInfo.clientAlias }}</span>
        <div class="el-divider el-divider--vertical"></div>
        <span>客户通路：{{ mainQualInfo.saleDeptDesc }}</span>
      </div>
      <div class="el-divider el-divider--horizontal">
        <div class="el-divider__text is-left">资质证明</div>
      </div>
      <el-tabs type="border-card">
        <el-tab-pane label="主体资质">
          <div class="tabBg" style="margin-top: 40px">
            <el-table
              :data="[mainQualInfo]"
              style="width: 100%"
              :header-row-class-name="headerRow"
              :row-class-name="rowClass"
              :cell-class-name="cellClass"
            >
              <el-table-column
                prop="qualificationTypeName"
                label="主体资质类型"
                width="180"
              >
                <template slot-scope="scope">
                  <div
                    v-bind:title="scope.row.qualificationTypeName"
                    class="text-index-t"
                  >
                    {{ scope.row.qualificationTypeName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="qualificationName"
                label="主体资质名称"
                width="240"
              >
                <template slot-scope="scope">
                  <div
                    v-bind:title="scope.row.qualificationName"
                    class="text-index-t"
                  >
                    {{ scope.row.qualificationName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="qualificationCode"
                label="主体资质编号"
                width="240"
              >
                <template slot-scope="scope">
                  <div
                    v-bind:title="scope.row.qualificationCode"
                    class="text-index-t"
                  >
                    {{ scope.row.qualificationCode }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="qualificationValidDate"
                label="有效期"
                width="150"
              >
              </el-table-column>
              <el-table-column prop="statusDesc" label="状态" width="145">
              </el-table-column>
              <el-table-column
                prop="updateTime"
                width="220"
                label="最后编辑时间"
              >
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="110">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.qualificationTypeName"
                    type="text"
                    @click="detailDialogVisible = true"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
              <div slot="empty" class="table-empty">
                <img
                  width="120px"
                  height="120px"
                  src="//n.sinaimg.cn/default/594854f7/20180713/table_empty.png"
                />
                <p>暂无资质信息</p>
              </div>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="行业资质">
          <div class="tabBg" style="margin-top: 20px">
            <el-radio-group
              v-model="selectedType"
              style="margin-left: 28px"
              size="medium"
            >
              <el-radio-button label="1">已过审资质</el-radio-button>
              <el-radio-button label="2">审核中资质</el-radio-button>
            </el-radio-group>
            <el-row :gutter="20" class="h80">
              <el-col :span="5">
                <el-input
                  @keyup.enter.native="searchQual"
                  v-model="search_word"
                  suffix-icon="el-icon-search"
                  placeholder="请输入资质包名称"
                  style="margin-left: 28px; line-height: 32px; height: 32px"
                ></el-input>
              </el-col>
              <el-col :span="15">
                <div class="grid-content"></div>
              </el-col>
              <el-col :span="4" style="text-align: right">
               
                <el-button
                  size="medium"
                  type="primary"
                  @click="jumpToQual"
                  style="margin-right: 28px"
                  >添加资质证明</el-button>
                 
              </el-col>
              <template v-if="selectedType == 1">
                <el-col class="tabBg">
                  <el-table
                    :data="passIndustryQualInfo.list"
                    style="width: 100%"
                    :header-row-class-name="headerRow"
                    :row-class-name="rowClass"
                    :cell-class-name="cellClass"
                  >
                    <el-table-column prop="packageId" label="包ID" width="240">
                    </el-table-column>
                    <el-table-column
                      prop="packageName"
                      label="名称"
                      width="220"
                    >
                      <template slot-scope="scope">
                        <div
                          v-bind:title="scope.row.packageName"
                          class="text-index-w"
                        >
                          {{ scope.row.packageName }}
                        </div>
                        <el-tooltip effect="light" placement="top">
                          <i
                            class="el-icon-warning icon-red"
                            v-if="scope.row.sevenPeriod"
                          />
                          <div slot="content">
                            <span>资质即将到期，请尽快变更</span>
                          </div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="industryDesc"
                      label="行业"
                      width="220"
                    >
                      <template slot-scope="scope">
                        <div
                          v-bind:title="scope.row.industryDesc"
                          class="text-index-t"
                        >
                          {{ scope.row.industryDesc }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="validityTime"
                      label="有效期"
                      width="160"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="statusDesc"
                      label="状态"
                      width="140"
                      class="colorzt"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.statusDesc }}
                        <el-tooltip
                          effect="light"
                          v-if="(scope.row.statusDesc == '驳回' || scope.row.statusDesc == '过期') && scope.row.subStatusDesc"
                          placement="top"
                        >
                          <i class="el-icon-warning icon-color" />
                          <div slot="content">
                            {{ scope.row.subStatusDesc }}
                          </div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="updateTime"
                      width="240"
                      label="最后编辑时间"
                    >
                    </el-table-column>
                    <el-table-column prop="src" width="240" label="来源">
                    </el-table-column>
                    <el-table-column prop="version" width="140" label="版本号">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="140">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          @click="show_qual_detail(scope.row, true)"
                          >查看</el-button
                        >
                        <el-button
                          type="text"
                          v-if="scope.row.editFlag"
                          @click="show_qual_mature_detail(scope.row)"
                          >编辑</el-button
                        >
                      </template>
                    </el-table-column>
                    <div slot="empty" class="table-empty">
                      <img
                        width="120px"
                        height="120px"
                        src="//n.sinaimg.cn/default/594854f7/20180713/table_empty.png"
                      />
                      <p>
                        暂无资质信息
                        <button @click="jumpToQual">
                          立即添加相关资质 &gt;
                        </button>
                      </p>
                    </div>
                  </el-table>
                </el-col>
                <el-col
                  class="pagination"
                  v-if="passIndustryQualInfo.count > 10"
                >
                  <div class="mar-bot-80">
                    <el-pagination
                      background
                      hide-on-single-page
                      :total="passIndustryQualInfo.count"
                      @current-page="change_page_qual"
                      :page-size="10"
                      layout="prev, pager, next, jumper"
                    ></el-pagination>
                  </div>
                </el-col>
              </template>
              <template v-else>
                <el-col class="tabBg">
                  <el-table
                    :data="inspectIndustryQualInfo.list"
                    style="width: 100%"
                    :header-row-class-name="headerRow"
                    :row-class-name="rowClass"
                    :cell-class-name="cellClass"
                  >
                    <el-table-column prop="packageId" label="包ID" width="260">
                    </el-table-column>
                    <el-table-column
                      prop="packageName"
                      label="名称"
                      width="260"
                    >
                      <template slot-scope="scope">
                        <div
                          v-bind:title="scope.row.packageName"
                          class="text-index-w"
                        >
                          {{ scope.row.packageName }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="industryDesc"
                      label="行业"
                      width="220"
                    >
                      <template slot-scope="scope">
                        <div v-bind:title="industryDesc" class="text-index-t">
                          {{ scope.row.industryDesc }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="validityTime"
                      label="有效期"
                      width="160"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="statusDesc"
                      label="审核状态"
                      width="160"
                      class="colorzt"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.statusDesc }}
                        <el-tooltip
                          effect="light"
                          v-if="(scope.row.statusDesc == '驳回' || scope.row.statusDesc == '过期') && scope.row.subStatusDesc"
                          placement="top"
                        >
                          <i class="el-icon-warning icon-color" />
                          <div slot="content">
                            {{ scope.row.subStatusDesc }}
                          </div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="updateTime"
                      width="240"
                      label="最后送审时间"
                    >
                    </el-table-column>
                    <el-table-column prop="src" width="220" label="来源">
                    </el-table-column>
                    <el-table-column prop="version" width="160" label="版本号">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="140">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          @click="show_qual_detail(scope.row)"
                          >查看</el-button
                        >
                        <el-button
                          type="text"
                          v-if="scope.row.editFlag"
                          @click="show_qual_detail(scope.row)"
                          >编辑</el-button
                        >
                      </template>
                    </el-table-column>
                    <div slot="empty" class="table-empty">
                      <img
                        width="120px"
                        height="120px"
                        src="//n.sinaimg.cn/default/594854f7/20180713/table_empty.png"
                      />
                      <p>暂无资质信息</p>
                    </div>
                  </el-table>
                </el-col>
                <el-col
                  class="pagination"
                  v-if="inspectIndustryQualInfo.count > 10"
                >
                  <div class="mar-bot-80">
                    <el-pagination
                      hide-on-single-page
                      background
                      :total="inspectIndustryQualInfo.count"
                      @current-page="change_page_qual"
                      :page-size="10"
                      layout="prev, pager, next, jumper"
                    ></el-pagination>
                  </div>
                </el-col>
              </template>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <z-layer ref="layer" :visible.sync="dialogVisible">
      <el-carousel type="card" height="400px" :interval="0">
        <el-carousel-item v-for="item in dialogImageUrl" :key="item">
          <img width="100%" :src="item" @click="img_click" title="点击可放大" />
        </el-carousel-item>
      </el-carousel>
    </z-layer>
    <CopyQualDialog
      :visible.sync="copyQualDialogVisible"
      @confirm="handleCopyConfirm"
      @preview="handleCopyPreview"
    />
    <el-dialog
      :visible.sync="detailDialogVisible"
      width="500px"
      append-to-body
      title="详情"
    >
      <el-form label-width="120px">
        <el-form-item label="客户编号">{{
          mainQualInfo.clientNumber
        }}</el-form-item>
        <el-form-item label="纳税码">{{
          mainQualInfo.qualificationCode
        }}</el-form-item>
        <el-form-item label="主体资质类型">{{
          mainQualInfo.qualificationTypeName
        }}</el-form-item>
        <el-form-item label="资质有效期">{{
          mainQualInfo.qualificationValidDate
        }}</el-form-item>
        <el-form-item label="经营范围">{{
          mainQualInfo.qualificationRange
        }}</el-form-item>
        <el-form-item label="资质图片">
          <img
            v-for="(item, index) in JSON.parse(mainQualInfo.qualificationImage)"
            :key="index"
            :src="item"
            width="80%"
          />
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import { getData, saveData } from "../utils/utils";
import layer from "@/components/dialoglayer/Layer";
import CopyQualDialog from "@/components/CopyQualDialog";
import qs from "qs";

export default {
  name: "Index",
  components: {
    "z-layer": layer,
    CopyQualDialog,
  },
  computed: {
    isBrandZZFlag: function () {
      return window.location.host.includes("brand");
    },
  },
  data: function () {
    return {
      pageInfo: {},
      mainQualInfo: { qualificationImage: "[]" },
      passIndustryQualInfo: { list: [], total: 0 },
      inspectIndustryQualInfo: { list: [], total: 0 },
      clientNumber: "",
      detailDialogVisible: false,
      copyQualDialogVisible: false,
      mainQualificationInfo: { data: [] },
      filter_data: [
        {
          text: "过期",
          value: 4,
        },
        {
          text: "有效",
          value: 2,
        },
        {
          text: "审核中",
          value: "1,6",
        },
        {
          text: "驳回",
          value: "3,5",
        },
      ],
      search_word: "",
      package_info: {},
      filter_status: "",
      currentPage: 1,
      dialogVisible: false,
      dialogImageUrl: [],
      selectedType: 1,
      currentPassPage: 1,
      currentInspectPage: 1,
    };
  },
  created: function () {
    if (this.isBrandZZFlag) {
      this.loginParam = this.$route.query["loginParam"];
      if (this.loginParam) {
        getData(
          "/api/crm/subject",
          {
            loginParam: this.loginParam,
          },
          (res) => {
            if (res.code == 0) {
              this.mainQualInfo = res.data;
            } else {
              this.$message.warning(res.msg);
            }
          }
        );
        this.get_pass_data();
      }
    } else {
      let params = {};
      if (this.$route.query["customer_id"]) {
        params["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        params["clientId"] = this.$route.query["clientId"];
      }
      getData("/api/package/list", params, (res) => {
        if (res.code == 0) {
          this.pageInfo = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      });
      getData(
        "/api/subject/query",
        params,
        (res) => {
          if (res.code == 0) {
            this.mainQualificationInfo = res.data;
          } else {
            this.$message.warning(res.msg);
          }
        },
        (eres) => {},
        false
      );
    }
  },
  watch: {
    selectedType(newVal) {
      if (newVal == 1) {
        this.currentPassPage = 1;
        this.get_pass_data();
      } else {
        this.currentInspectPage = 1;
        this.get_inspect_data();
      }
    },
  },
  methods: {
    show_detail: function (row) {
      let url = "/qulification/" + row.packageId;
      let urlHash = {};
      if (this.$route.query["customer_id"]) {
        urlHash["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        urlHash["clientId"] = this.$route.query["clientId"];
      }
      url =
        Object.keys(urlHash).length > 0
          ? url + `?${qs.stringify(urlHash)}`
          : url;
      this.$router.push(url);
    },
    show_mature_detail: function (row) {
      let url = "/qulification/mature/" + row.packageId;
      let urlHash = {};
      if (this.$route.query["customer_id"]) {
        urlHash["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        urlHash["clientId"] = this.$route.query["clientId"];
      }
      url =
        Object.keys(urlHash).length > 0
          ? url + `?${qs.stringify(urlHash)}`
          : url;
      this.$router.push(url);
    },
    show_qual_detail: function (row, checkFlag = false) {
      let url = "/qulification/" + row.packageId;
      let urlHash = {};
      if (this.$route.query["loginParam"]) {
        urlHash["loginParam"] = this.$route.query["loginParam"];
      }
      if (checkFlag) {
        urlHash["checkFlag"] = true;
      }
      url =
        Object.keys(urlHash).length > 0
          ? url + `?${qs.stringify(urlHash)}`
          : url;
      this.$router.push(url);
    },
    show_qual_mature_detail: function (row) {
      let url = "/qulification/mature/" + row.packageId;
      let urlHash = {};
      if (this.$route.query["loginParam"]) {
        urlHash["loginParam"] = this.$route.query["loginParam"];
      }
      url =
        Object.keys(urlHash).length > 0
          ? url + `?${qs.stringify(urlHash)}`
          : url;
      this.$router.push(url);
    },
    show_images: function (dialogImageUrl) {
      this.dialogVisible = true;
      this.dialogImageUrl = dialogImageUrl;
    },
    get_pass_data: function () {
      let params = {
        packageName: this.search_word,
        current: this.currentPassPage,
        pageSize: 10,
      };
      if (this.$route.query["loginParam"]) {
        params["loginParam"] = this.$route.query["loginParam"];
      }
      getData("/api/package/crm/pass/list", params, (res) => {
        if (res.code == 0) {
          this.passIndustryQualInfo = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    get_inspect_data: function () {
      let params = {
        packageName: this.search_word,
        current: this.currentInspectPage,
        pageSize: 10,
      };
      if (this.$route.query["loginParam"]) {
        params["loginParam"] = this.$route.query["loginParam"];
      }
      getData("/api/package/crm/inspect/list", params, (res) => {
        if (res.code == 0) {
          this.inspectIndustryQualInfo = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    change_page: function (currentPage) {
      this.currentPage = currentPage;
      let params = {
        package_name: this.search_word,
        page: this.currentPage,
        status: this.filter_status,
      };
      if (this.$route.query["customer_id"]) {
        params["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        params["clientId"] = this.$route.query["clientId"];
      }
      getData("api/package/list", params, (res) => {
        if (res.code == 0) {
          this.pageInfo.cards.table = res.data.cards.table;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    change_page_qual: function (currentPage) {
      if (this.selectedType == 1) {
        this.currentPassPage = currentPage;
        this.get_pass_data();
      } else {
        this.currentInspectPage = currentPage;
        this.get_inspect_data();
      }
    },
    handlerFilterChange: function (filters) {
      if (filters.status) {
        this.filter_status = filters.status.join(",");
      } else {
        this.filter_status = "";
      }
      this.currentPage = 1;
      let params = {
        package_name: this.search_word,
        page: this.currentPage,
        status: this.filter_status,
      };
      if (this.$route.query["customer_id"]) {
        params["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        params["clientId"] = this.$route.query["clientId"];
      }
      getData("api/package/list", params, (res) => {
        if (res.code == 0) {
          this.pageInfo.cards.table = res.data.cards.table;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    jump: function () {
      let params = {};
      if (this.$route.query["customer_id"]) {
        params["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        params["clientId"] = this.$route.query["clientId"];
      }
      getData(
        "/api/subject/check",
        params,
        (res) => {
          if (res.code == 0) {
            if (!res.data) {
              this.$confirm(
                "您当前并无主体资质，无法提交行业资质",
                "添加失败",
                {
                  center: true,
                  showClose: false,
                  confirmButtonText: "添加主体资质",
                  cancelButtonText: "取消",
                }
              )
                .then(() => this.jumpToPro())
                .catch(() => {});
            } else {
              getData(
                "/api/package/getTemp",
                params,
                (res) => {
                  if (res.code == 0) {
                    if (res.data.packageId) {
                      this.$confirm(
                        "您有一个未完成的资质证明，是否继续填写",
                        "",
                        {
                          confirmButtonText: "确定",
                          cancelButtonText: "取消",
                          center: true,
                          showClose: false,
                        }
                      )
                        .then(() => {
                          let url = "/qulification/base/" + res.data.packageId;
                          let urlHash = {};
                          if (this.$route.query["customer_id"]) {
                            urlHash["customer_id"] =
                              this.$route.query["customer_id"];
                          }
                          if (this.$route.query["clientId"]) {
                            urlHash["clientId"] = this.$route.query["clientId"];
                          }
                          url =
                            Object.keys(urlHash).length > 0
                              ? url + `?${qs.stringify(urlHash)}`
                              : url;
                          this.$router.push(url);
                        })
                        .catch(() => {});
                    } else {
                      let url = "/qulification/base/";
                      let urlHash = {};
                      if (this.$route.query["customer_id"]) {
                        urlHash["customer_id"] =
                          this.$route.query["customer_id"];
                      }
                      if (this.$route.query["clientId"]) {
                        urlHash["clientId"] = this.$route.query["clientId"];
                      }
                      url =
                        Object.keys(urlHash).length > 0
                          ? url + `?${qs.stringify(urlHash)}`
                          : url;
                      this.$router.push(url);
                    }
                  } else {
                    this.$message.warning(res.msg);
                    return false;
                  }
                },
                (eres) => {},
                false
              );
            }
          } else {
            this.$message.warning(res.msg);
            return false;
          }
        },
        (eres) => {},
        false
      );
    },
    copyQual() {
      this.copyQualDialogVisible = true;
    },
    handleCopyConfirm(row) {
      console.log("复制的行数据：", row);
      let url = "/qulification/mature/license/copy/"+row.packageId;
      let urlHash = {};
      if (this.$route.query["customer_id"]) {
        urlHash["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        urlHash["clientId"] = this.$route.query["clientId"];
      }
      url =
        Object.keys(urlHash).length > 0
          ? url + `?${qs.stringify(urlHash)}`
          : url;
      window.open(url, "_blank");
      this.copyQualDialogVisible = false;
    },

    handleCopyPreview(row) {
      let url = "/qulification/" + row.packageId;
      let urlHash = {};
      if (this.$route.query["customer_id"]) {
        urlHash["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        urlHash["clientId"] = this.$route.query["clientId"];
      }
      url =
        Object.keys(urlHash).length > 0
          ? url + `?${qs.stringify(urlHash)}`
          : url;
      window.open(url, "_blank");
    },
    jumpToQual: function () {
      let params = {};
      if (this.$route.query["loginParam"]) {
        params["loginParam"] = this.$route.query["loginParam"];
      }
      getData(
        "/api/crm/subject/check",
        params,
        (res) => {
          if (res.code == 0) {
            if (!res.data) {
              this.$confirm(
                "您当前并无主体资质，无法提交行业资质",
                "添加失败",
                {
                  confirmButtonText: "添加主体资质",
                  cancelButtonText: "取消",
                  showClose: false,
                  center: true,
                }
              )
                .then(() => {
                  this.jumpToPro();
                })
                .catch(() => {});
            } else {
              getData(
                "/api/package/crm/getTemp",
                params,
                (res) => {
                  if (res.code == 0) {
                    if (res.data && res.data.packageId) {
                      this.$confirm(
                        "您有一个未完成的资质证明，是否继续填写",
                        "",
                        {
                          confirmButtonText: "确定",
                          cancelButtonText: "取消",
                          center: true,
                          showClose: false,
                        }
                      )
                        .then(() => {
                          let url = "/qulification/base/" + res.data.packageId;
                          let urlHash = {};
                          if (this.$route.query["loginParam"]) {
                            urlHash["loginParam"] =
                              this.$route.query["loginParam"];
                          }
                          url =
                            Object.keys(urlHash).length > 0
                              ? url + `?${qs.stringify(urlHash)}`
                              : url;
                          this.$router.push(url);
                        })
                        .catch(() => {});
                    } else {
                      let url = "/qulification/base/";
                      let urlHash = {};
                      if (this.$route.query["loginParam"]) {
                        urlHash["loginParam"] = this.$route.query["loginParam"];
                      }
                      url =
                        Object.keys(urlHash).length > 0
                          ? url + `?${qs.stringify(urlHash)}`
                          : url;
                      this.$router.push(url);
                    }
                  } else {
                    this.$message.warning(res.msg);
                    return false;
                  }
                },
                (eres) => {},
                false
              );
            }
          } else {
            this.$message.warning(res.msg);
            return false;
          }
        },
        (eres) => {},
        false
      );
    },
    jumpToPro: function (data = {}, type = 2) {
      //新增以及修改主体资质
      let params = {};
      if (this.$route.query["customer_id"]) {
        params["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        params["clientId"] = this.$route.query["clientId"];
      }
      params["queryCompile"] = type;
      params["recordType"] = data.recordType || 1;
      if (data.serialNumber) {
        params["serialNumber"] = data.serialNumber;
      }
      saveData(
        "/api/subject/update",
        params,
        (res) => {
          if (res.code == 0) {
            window.open(res.data.url, "_blank");
          } else {
            this.$message.warning(res.msg);
          }
        },
        (eres) => {},
        true
      );
    },
    jumpHelpCenter: function () {
      let params = {};
      if (this.$route.query["customer_id"]) {
        params["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        params["clientId"] = this.$route.query["clientId"];
      }
      this.$router.push(
        `/help${
          Object.keys(params).length > 0 ? `?${qs.stringify(params)}` : ""
        }`
      );
    },
    img_click: function (event) {
      window.open(event.target.src, "_blank");
    },
    cellClass: function ({ row, column, rowIndex, columnIndex }) {
      // 主体资质临期30天 标红
      if (row.validityStatus) {
        return "reject";
      }
      // 行业资质临期 标红
      if (row.sevenPeriod) {
        return "reject";
      }
      // 主体资质无效 置灰
      if (row.status == 0) {
        return "expired";
      }
      if (column.label === "状态") {
        if (row.status_type === "过期") {
          return "expired";
        }
        if (row.status_type === "有效") {
          return row.industry_status === 0 ? "effective" : "reject";
        }
        if (row.status_type === "审核中") {
          return "review";
        }
        if (row.status_type === "驳回") {
          return "reject";
        }
        // if (row.desc === '无效') {
        //   return 'expired'
        // }
        if (row.desc === "有效") {
          return "effective";
        }
        if (row.desc === "审核中") {
          return "review";
        }
        if (row.desc === "驳回" || row.status == "6") {
          return "reject";
        }
        if (row.statusDesc === "有效") {
          return "effective";
        }
        if (row.statusDesc === "审核中") {
          return "review";
        }
        if (row.statusDesc === "驳回") {
          return "reject";
        }
        if (row.statusDesc === "过期") {
          return "expired";
        }
      }
      if (column.label === "审核状态") {
        if (row.statusDesc === "有效") {
          return "effective";
        }
        if (row.statusDesc === "审核中") {
          return "review";
        }
        if (row.statusDesc === "驳回") {
          return "reject";
        }
      }
    },
    headerRow: function ({ row, rowIndex }) {
      if (rowIndex === 0) {
        return "header-row";
      }
    },
    rowClass: function ({ row, rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "row-bg";
      }
      return "row-class";
    },
    search: function () {
      this.currentPage = 1;
      let params = {
        package_name: this.search_word,
        page: this.currentPage,
        status: this.filter_status,
      };
      if (this.$route.query["customer_id"]) {
        params["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        params["clientId"] = this.$route.query["clientId"];
      }
      getData("api/package/list", params, (res) => {
        if (res.code == 0) {
          this.pageInfo.cards.table = res.data.cards.table;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    searchQual: function () {
      if (this.selectedType == 1) {
        this.currentPassPage = 1;
        this.get_pass_data();
      } else {
        this.currentInspectPage = 1;
        this.get_inspect_data();
      }
    },
    checkEditFlag(data) {
      if (!this.mainQualificationInfo.reviewing) {
        if (this.mainQualificationInfo.data.some((item) => item.status == 6)) {
          return data.status == 6;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
.table-empty {
  width: 100%;
  height: 100%;
  margin-top: -100px;
}

.table-empty p {
  margin-top: 15px;
  font-size: 12px;
  font-family: PingFangSC-Regular;
}

.table-empty button {
  color: #2a60e4;
  background: transparent;
  border: none;
  cursor: pointer;
  outline: 0;
}

.table-empty p {
  margin-top: 15px;
  font-size: 12px;
  font-family: PingFangSC-Regular;
}

.table-empty button {
  color: #2a60e4;
  background: transparent;
  border: none;
  cursor: pointer;
  outline: 0;
}

.borders-shadow .w-input-new_wrapper_GBwX0 .w-input-new_medium_1J3Pq {
  font-size: 12px;
  font-family: PingFangSC-Regular;
  width: 210px;
}

.pagination input {
  max-width: 66px;
  height: 80px;
  line-height: 80px;
}

.borders-shadow .w-input-new_wrapper_GBwX0 .w-input-new_medium_1J3Pq {
  font-size: 12px;
  font-family: PingFangSC-Regular;
  width: 210px;
}

.pagination input {
  max-width: 66px;
  height: 80px;
  line-height: 80px;
}

.panel-item {
  height: 94px;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.panel-item .f-weight {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #2e334a;
  letter-spacing: 0.83px;
  text-align: center;
  line-height: 18px;
}

.panel-item .s_txt {
  opacity: 0.7;
  font-size: 12px;
  color: #596597;
  padding-top: 20px;
}

.text-index {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-index-w {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 230px;
}
.text-index-t {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 190px;
}
.zizhi-tips {
  font-size: 12px;
  color: #2e334a;
  line-height: 20px;
  display: block;
  text-align: left;
  width: 364px;
  height: 30px;
  padding: 10px 8px 15px 10px;
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 38px;
  padding-left: 28px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.expired {
  color: #a5abc6;
}

.effective {
  color: #07175d;
}

.review {
  color: #75b430;
}

.reject {
  color: #c82439;
}

.header-row > th {
  padding: 0;
  background: #ebf0fb;
  padding-left: 30px;
  padding-right: 30px;
}

.table-action-column {
  padding-right: 30px;
}

.colorzt {
  color: #2a60e4;
}

.row-class > td {
  padding-left: 30px;
}

.icon-color-gray {
  position: relative;
  top: 0px;
  font-size: 14px;
  color: #a5abc6;
}

.row-bg > td {
  padding-left: 30px;
  background: #f9fafd;
}

.icon-gray {
  position: absolute;
  top: 25px;
  left: 15px;
  font-size: 14px;
  color: #a5abc6;
}
.icon-red {
  position: absolute;
  top: 25px;
  left: 15px;
  font-size: 14px;
  color: #c82439;
}

.icon-color-show {
  font-size: 14px;
  color: #2a60e4;
  cursor: pointer;
  margin: 0 8px;
}

.icon-color-delete {
  font-size: 18px;
  color: #c82439;
  border-radius: 1px;
}

.tabBg {
  min-height: 568px;
  font-size: 14px;
  color: #07175d;
  line-height: 14px;
}

.tabBg .el-table__empty-block {
  min-height: 531px;
}

.tabBg table thead {
  height: 35px;
  line-height: 35px;
  background: #ebf0fb;
  padding-right: 30px;
}

.tabBg .el-table__empty-block {
  min-height: 531px;
}

.ad_tit {
  width: 148px;
  font-size: 18px;
  color: #2e334a;
  font-weight: bold;
  height: 66px;
  line-height: 66px;
}
.help_tit {
  font-size: 14px;
  color: blue;
  font-weight: bold;
  height: 66px;
  line-height: 66px;
  cursor: pointer;
  float: right;
  position: relative;
}
.help_tit::after {
  position: absolute;
  content: "new";
  font-size: 12px;
  color: red;
  left: 60px;
  top: -10px;
}
.help_tit:hover {
  text-decoration: underline;
}
.el-tooltip__popper.is-light {
  border: 1px solid #cccccc;
}

.el-tooltip__popper.is-light[x-placement^="top"] .popper__arrow {
  border-top-color: #cccccc;
}

.mar-bot-80 {
  margin: 0 0 40px;
  text-align: center;
}
.mar-bot-80 .w-input_wrapper_1Qoyh {
  height: 36px;
  overflow: hidden;
  margin-bottom: -10px;
  line-height: 36px;
  vertical-align: middle;
}
.mar-bot-80 .w-input_wrapper_1Qoyh .w-input_common_ku1LS.w-input_mini_hphiK {
  height: 30px;
  line-height: 30px;
  color: #4d5060;
}

.mar-bot-80 .el-pagination {
  height: 30px;
  line-height: 30px;
  color: #4d5060;
}
.w-panel_panel-body_3HItY {
  padding: 21px 15px !important;
}
.el-tabs--border-card > .el-tabs__content {
  padding: 0;
}
.el-carousel__mask {
  background: transparent;
}
.el-divider {
  background-color: #dcdfe6;
  position: relative;
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 24px 0;
}
.el-divider__text.is-left {
  left: 20px;
  transform: translateY(-50%);
}
.el-divider__text {
  position: absolute;
  background-color: rgb(249, 249, 249);
  padding: 0 20px;
  font-weight: 500;
  color: #303133;
  font-size: 16px;
}
.el-divider--vertical {
  display: inline-block;
  width: 1px;
  height: 28px;
  margin: 0 8px;
  vertical-align: middle;
  position: relative;
}
.el-divider {
  background-color: #dcdfe6;
}
.el-input__inner {
  height: 32px;
  line-height: 32px;
}
.el-input__icon {
  line-height: 32px;
}
.cust-info {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue